import { render, staticRenderFns } from "./header-items-lg-xl.vue?vue&type=template&id=c5fd1940&scoped=true&"
import script from "./header-items-lg-xl.vue?vue&type=script&lang=js&"
export * from "./header-items-lg-xl.vue?vue&type=script&lang=js&"
import style0 from "./header-items-lg-xl.vue?vue&type=style&index=0&id=c5fd1940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fd1940",
  null
  
)

export default component.exports